import { ValuationType } from '@aviv-estimation-funnel/estimation-data-models/enums/valuation-type.enum';
import { Box } from '@gemini/core';
import EstimateFeedbackModal from '@mfe-presentation/components/EstimateFeedbackModal';
import { NAME_SPACE } from '@mfe-presentation/hooks/useLoadTranslations';

const EstimateFeedback = ({ type }: { type: ValuationType }) => {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            textAlign="center"
            paddingTop="spacing.16"
            paddingHorizontal="spacing.8"
            marginTop="spacing.16"
            marginHorizontal="spacing.16"
            borderTopColor="color.surface.subdued.default"
            borderTopWidth="borderWidth.1"
            borderTopStyle="solid"
            borderBottomLeftRadius={{
                'breakpoint.base': 'radius.8',
                'breakpoint.sm': 'radius.none',
            }}
            borderBottomRightRadius={{
                'breakpoint.base': 'radius.8',
                'breakpoint.sm': 'radius.none',
            }}
        >
            <EstimateFeedbackModal type={type} />
        </Box>
    );
};

export default EstimateFeedback;
